export const PERIOD = 'depositPeriod';
export const AMOUNT = 'depositAmount';
export const COUNT = 'depositsCount';
export const DAYS_TO_DEPOSIT = 'daysToDeposit';
export const DAYS_SINCE_LAST_DEPOSIT = 'daysSinceLastDepositFrom';
export const TOP_DEPOSITORS = 'topDepositors';
